export default __webpack_public_path__ + "static/media/background.b46ef3a1.jpg";